/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { numberDependencies } from './dependenciesNumber.generated.js';
import { createNumeric } from '../../factoriesNumber.js';
export var numericDependencies = {
  numberDependencies,
  createNumeric
};